<template>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="4">
        <v-card class="elevation-12 mt-10 mt-lg-16 mt-md-16 mt-sm-16">
          <v-card-title
            class="justify-center"
            style="
              background-color: rgb(30, 101, 105);
              margin-bottom: 30px;
              padding-top: 20px !important;
            "
          >
            <img src="../../assets/img/logo_w.svg" style="width: 100%" alt="" />
          </v-card-title>

          <v-card-text class="justify-center px-9 px-md-13 px-sm-9 px-lg-16"
            ><v-row justify="center">
              <p v-text="$t('AdminPage.AdminLoginText')" class="pb-2" />
            </v-row>
            <validation-observer ref="observer">
              <v-form @keyup.native.enter="login">
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('Headers.first_name')"
                  rules="required|user"
                >
                  <v-text-field
                    filled
                    :label="$t('AdminPage.Email')"
                    prepend-inner-icon="mdi-account"
                    v-model="user.email"
                    type="email"
                    name="email"
                    data-cy="loginEmail"
                    :error-messages="errors"
                  ></v-text-field>
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('Headers.first_name')"
                  rules="required"
                >
                  <v-text-field
                    filled
                    :label="$t('Headers.password')"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    prepend-inner-icon="mdi-lock"
                    v-model="user.password"
                    name="password"
                    data-cy="loginPassword"
                    :error-messages="errors"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </validation-provider>
              </v-form>
              <v-card-actions class="justify-center">
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <custom-button
                      v-bind:block="false"
                      @click="login"
                      :text="$t('Navigation.login')"
                      type="submit"
                      data-cy="loginSubmit"
                    />
                  </v-col>
                </v-row>
              </v-card-actions>
            </validation-observer>
            <v-row justify="center">
              <v-col cols="12" class="text-center">
                <custom-link
                  link="/register"
                  :text="$t('AdminPage.Login_Register')"
                  target="_self"
                ></custom-link>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <custom-link
                  link="/forgot"
                  :text="$t('AdminPage.Login_Forgot')"
                  target="_self"
                ></custom-link>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import CustomButton from "../../components/ui/input/CustomButton";
import CustomLink from "../../components/ui/text/HyperLink.vue";
import i18n from "@/i18n";
import {
  extend,
  ValidationProvider,
  setInteractionMode,
  ValidationObserver,
} from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { log } from "@/helpers/logger";

setInteractionMode("eager");

/**
 * @vue-data {Dictionary} user - user data
 * @vue-data {Boolean}[loading=false] loading - gives, if content is loaded
 * @vue-event {} login() - logs user in
 */

extend("required", {
  ...required,
  message: i18n.t("FormValidation.required"),
});

extend("user", {
  ...email,
  message: i18n.t("FormValidation.user"),
});

export default {
  name: "Login",
  title: i18n.t("HomePage.header.admin"),
  components: {
    CustomButton,
    CustomLink,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
        mainColor: "rgb(30, 101, 104)",
      },
      showPassword: false,
    };
  },
  computed: {
    loadingState() {
      return this.$store.state.loading;
    },
  },
  created() {
    this.$store
      .dispatch("auth/logoutAdmin")
      .then(() => {
        log("AdminPage.Login.created() - Logout Admin", "info");
      })
      .catch((err) => {
        log("AdminPage.Login.created() -" + err, "error");
      });
  },
  methods: {
    async login() {
      this.$store
        .dispatch("auth/login", this.user)
        .then(async () => {
          log("AdminPage.Login.login() - login user " + this.user.email, "info");
          var logged_user = this.$store.state.auth.user;
          this.$vuetify.theme.themes.light.primary = logged_user
            ? logged_user.whitelabeling_pack.style
            : "rgb(30, 101, 104)";
          this.$vuetify.theme.themes.light.secondary = logged_user
            ? logged_user.whitelabeling_pack.style
            : "rgb(30, 101, 104)";
          this.$vuetify.theme.themes.light.accent = logged_user
            ? logged_user.whitelabeling_pack.style
            : "rgb(30, 101, 104)";
        })
        .finally(() => {
          this.$router.push("/admin");
        })
        .catch((err) => {
          log("AdminPage.Login.login - " + err, "error");
        });
    },
  },
};
</script>
